import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { environment } from '@src/environments/environment';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { ContainerModel } from '@app/models/server/layout.model';

@Component({
  selector: 'app-b2b-login-pop-over',
  templateUrl: './b2b-login-pop-over.component.html',
  styleUrls: ['./b2b-login-pop-over.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, NgOptimizedImage],
})
export class B2bLoginPopOverComponent implements OnInit {
  @Input() compData: {
    container?: ContainerModel;
    loaded?: (value: any) => void;
  };

  showPopover: boolean = Boolean(true);

  // userInfo$: Observable<UserModel>;

  // isDesktop: boolean = this.b2bDeviceUtilService.isDesktop();
  isWebApp: boolean = environment.webApp;

  platform: string = this.b2bDeviceUtilService?.getWebPlatform();
  isServer: boolean = this.b2bDeviceUtilService?.isServer();
  isDesktop: boolean = this.b2bDeviceUtilService?.isDesktop();

  appLink: string;
  appBarCode: string;

  // placeHolderImage: string = NEW_IMAGE_PLACEHOLDERS?.hotel;

  constructor(
    // private modalController: ModalController,
    // private store: Store<fromRoot.State>,
    private b2bDeviceUtilService: B2bDeviceUtilService,
  ) {}

  ngOnInit() {
    if (this.isWebApp) {
      this.appLink = this.b2bDeviceUtilService.getMobileAppLink();
      if (this.isDesktop) {
        this.appBarCode = this.b2bDeviceUtilService.getMobileAppLinkBarCode();
      } else {
        // TODO mobile web case
      }
    } else {
      // TODO mobile app register or login button
    }
    // this.userInfo$ = this.store.pipe(select(initUser.getUser));
  }

  dismiss() {
    this.showPopover = false;
  }

  /*  async openLoginPopup() {
      const module = await import('@b2b/auth-lib');

      const componentProps: {
        compData: {
          pageType: string;
          isModal: boolean;
          disablePageNavigation: boolean;
        };
      } = {
        compData: {
          pageType: 'login',
          isModal: true,
          disablePageNavigation: true,
        },
      };

      const modal: HTMLIonModalElement = await this.modalController.create({
        component: module.AuthModalComponent,
        componentProps,
        initialBreakpoint: 1,
        cssClass: 'auth-modal',
      });

      modal.onDidDismiss().then((result: OverlayEventDetail<{}>) => {
        // LoggerService.log('Login popup ', result.data);
        if (result && result?.data) {
        }
      });
      return await modal.present();
    }*/
}
